import * as React from "react";
import moment from 'moment'
import { useLocalize } from "@/modules/shared/context/localize/LocalizeContext";
import { RepeatableSection } from "../components/RepeatableSection";
import { CurrencyModel } from "@/app/models/newDelegation/currencyModel";
import { MinimumWageAccomodationExpandableItemModel } from "@/app/models/configuration/minimumWage/minimumWageAccomodationExpandableItemModel";
import { MinimalCountryAccomodationType } from "@/app/constants/configuration/minimalCountryAccomodationType";

type Props = {
    title?: string
    readOnly?: boolean
    allowedCurrencies?: string[]
    state: {
        configuration: { currencies: CurrencyModel[] }
        accomodationExpandableItems: MinimumWageAccomodationExpandableItemModel[]
    }
    setState: React.Dispatch<React.SetStateAction<{ accomodationExpandableItems: MinimumWageAccomodationExpandableItemModel[] }>>
}

export const MinimumWageAccomodationExpandableItemSection = ({ readOnly, allowedCurrencies, title, state, setState }: Props) => {
    const { t } = useLocalize()

    return (
        <RepeatableSection<MinimumWageAccomodationExpandableItemModel>
            title={title || t('configuration.minimumWages.minimalAccommodationAdditionTitle')}
            newRow={() => ({
                accomodationCurrency: { id: 1, code: "PLN", name: "złoty" },
                accomodationValue: 0,
                accomodationType: MinimalCountryAccomodationType.Day,
                configurationValueId: 0,
                dateFrom: moment(),
                isNew: true,
            })}
            readOnly={readOnly}
            columns={[
                {
                    order: 1,
                    label: t('configuration-minimumWage.from-date'),
                    type: "date",
                    readOnly,
                    get: (r) => r.dateFrom,
                    set: (r, v) => ({ ...r, dateFrom: moment(v) }),
                },
                {
                    order: 3,
                    label: t('common.amount'),
                    type: "price",
                    readOnly,
                    get: (r) => r.accomodationValue,
                    set: (r, v: number) => ({ ...r, accomodationValue: Number(v) }),
                },
                {
                    order: 5,
                    label: t("configuration.countries.currency"),
                    type: "select", //"currency",
                    readOnly,
                    options: state.configuration.currencies.filter(c => Array.isArray(allowedCurrencies) ? allowedCurrencies.includes(c.code) : true).map((c) => ({ label: `${c.code} - ${c.name}`, value: c.code })).sort((a, b) => a.label.localeCompare(b.label)),
                    get: (r) => r.accomodationCurrency.code,
                    set: (r, v) => {
                        const selected = state.configuration.currencies.find(c => c.code === v)
                        return ({ ...r, accomodationCurrency: selected })
                    }
                },
                {
                    order: 6,
                    label: t('common.type'),
                    type: "select", //"type month/year",
                    readOnly,
                    options: [
                        { label: 'Day', value: MinimalCountryAccomodationType.Day.toString(), },
                        { label: 'Month', value: MinimalCountryAccomodationType.Month.toString(), },
                    ],
                    get: (r) => r.accomodationType,
                    set: (r, v) => {
                        return ({ ...r, accomodationType: v as MinimalCountryAccomodationType })
                    }
                },
            ]}
            canAddRow={true}
            rows={state.accomodationExpandableItems}
            setRows={(next) => {
                setState(prev => {
                    const current = prev.accomodationExpandableItems;
                    const nextRows = typeof next === "function" ? (next as (p: typeof current) => typeof current)(current) : next;
                    return { ...prev, accomodationExpandableItems: nextRows };
                });
            }}
            sortRows={(a, b) => {
                const da = moment(a.dateFrom)
                const db = moment(b.dateFrom)
                const ta = da.valueOf()
                const tb = db.valueOf()
                if(ta===tb) return 0
                return ta > tb ? -1 : 1
            }}
        />
    )
}
